<template>
  <v-row justify="space-between" class="dark-gray-background px-4 px-md-10">
    <v-col md="6" lg="4" cols="12" class="pa-2 pb-0">
      <v-row class="pa-2 pb-0">
        <v-col cols="12" class="pa-md-0 pb-0">
          <v-row class="dark-gray-background">
            <v-col md="8" class="yellow-font">
              <h1 class="display-24 px-2 yellow-font">
                {{ MainCubeConstants.Keys[0].KeyValue.Value }}
              </h1>
            </v-col>
            <v-col class="yellow-font display-24">
              <p class="text-left">
                {{ MainCubeConstants.Keys[1].KeyValue.Value }}
              </p>
            </v-col>
          </v-row>
          <v-row class="px-0 px-md-2" justify-xs="center" justify-md="start">
            <v-col class="pb-0">
              <p class="text-center text-md-right">
                <nuxt-link
                  :to="'/'"
                  class="border-none headerLogo"
                  title="דרושים IL"
                >
                  <img
                    :src="MainCubeConstants.Keys[2].KeyValue.Value"
                    alt="logo"
                  />
                </nuxt-link>
              </p>
            </v-col>
          </v-row>
          <v-row class="dark-gray-background white--text pb-3 px-3 pt-2">
            <p
              class="px-2 display-16-12 text-center text-md-right"
              v-html="MainCubeConstants.Keys[3].KeyValue.Value"
            />
          </v-row>

          <v-row class="show">
            <v-col class="info-col rounded py-0" cols="12">
              <ProgressBar
                :Demand="Demand"
                :Supply="Supply"
                :Measure="Measure"
                :texts="IndexesConstants"
              />
            </v-col>
          </v-row>

          <v-row class="ma-md-0 mt-3 flex-nowrap">
            <InfoCube
              :colorClass="'carrot-font'"
              :info="CompetitionCubeConstants"
            />
            <InfoCube :colorClass="'mango-font'" :info="EffortCubeConstants" />
          </v-row>
        </v-col>
      </v-row>
      <v-row class="pa-3">
        <v-col class="info-col rounded" cols="12">
          <v-row class="px-2 pt-2 pt-md-4">
            <v-col cols="1" class="pl-0">
              <v-tooltip
                :open-on-click="true"
                :open-on-hover="true"
                bottom
                color="#525867"
                :max-width="$vuetify.breakpoint.xs ? '90%' : '33%'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <img
                    v-bind="attrs"
                    v-on="on"
                    src="/employment_index/Qustion.png"
                    width="22px"
                    alt="info"
                    class="v-align-middle"
                  />
                </template>

                <span
                  class="display-18"
                  v-html="CurrentDemandConstants.Keys[3].KeyValue.Value"
                ></span>
              </v-tooltip>
            </v-col>

            <v-col class="pr-md-2 pr-4">
              <p class="display-20 mango-font mb-0">
                {{ CurrentDemandConstants.Keys[0].KeyValue.Value }}
              </p>
              <p class="display-20 mb-0">
                <span class="white--text">
                  {{ CurrentDemandConstants.Keys[1].KeyValue.Value }}
                </span>
              </p>
              <p class="white--text display-16 mb-0">
                {{ CurrentDemandConstants.Keys[2].KeyValue.Value }}
              </p>
            </v-col>

            <iframe
              class=""
              :src="MostDemagedDomainsGraphLink"
              frameborder="0"
              width="100%"
              :height="$vuetify.breakpoint.xs ? '300px' : '480px'"
            ></iframe>
          </v-row>
        </v-col>
      </v-row>
    </v-col>

    <v-col md="6" lg="4" cols="12">
      <v-row class="pa-2">
        <v-col class="info-col rounded py-0" cols="12" :class="'hide'">
          <ProgressBar
            :Demand="Demand"
            :Supply="Supply"
            :Measure="Measure"
            :texts="IndexesConstants"
          />
        </v-col>
      </v-row>

      <v-row class="pa-2">
        <v-col class="info-col rounded mb-3" cols="12">
          <v-row class="px-2 pt-1 white--text">
            <v-col cols="1" class="pl-0">
              <v-tooltip
                :open-on-click="true"
                :open-on-hover="true"
                bottom
                color="#525867"
                :max-width="$vuetify.breakpoint.xs ? '90%' : '33%'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <img
                    v-bind="attrs"
                    v-on="on"
                    src="/employment_index/Qustion.png"
                    width="22px"
                    alt="info"
                    class="v-align-middle"
                  />
                </template>
                <span
                  class="display-18"
                  v-html="CategoriesConstants.Keys[6].KeyValue.Value"
                ></span>
              </v-tooltip>
            </v-col>

            <v-col class="pr-md-2 pr-4">
              <p class="display-20 mb-0 mango-font">
                {{ CategoriesConstants.Keys[4].KeyValue.Value }}
              </p>
              <p class="display-16 mb-0">
                {{ CategoriesConstants.Keys[5].KeyValue.Value }}
              </p>
            </v-col>

            <iframe
              class=""
              :src="CategoriesGraphLinkSupply"
              frameborder="0"
              width="100%"
              :height="$vuetify.breakpoint.xs ? '300px' : '265px'"
            ></iframe>
          </v-row>
        </v-col>

        <v-col class="info-col rounded pa-2">
          <v-row class="pt-2 px-4">
            <v-col class="employment rounded white--text px-12">
              <p class="mango-font display-20 px-1 mb-0">
                {{ CategoriesConstants.Keys[0].KeyValue.Value }}
              </p>
              <v-row>
                <v-col cols="10" class="py-0 my-0">
                  <v-select
                    v-model="displayCategory"
                    :items="Categories"
                    :placeholder="CategoriesConstants.Keys[7].KeyValue.Value"
                    item-text="NameInHebrew"
                    item-value="Code"
                    class="white--text px-2 mt-0 py-0"
                    id="what-search"
                    dark
                  ></v-select>
                </v-col>
                <v-col class="align-self-center">
                  <v-row>
                    <img
                      src="/employment_index/arrow01.png"
                      width="32px"
                      class="pointer"
                      alt="search"
                      @click="submitCategory"
                    />
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="px-2 pt-1 white--text">
            <v-col cols="1" class="pl-0">
              <v-tooltip
                :open-on-click="true"
                :open-on-hover="true"
                bottom
                color="#525867"
                :max-width="$vuetify.breakpoint.xs ? '90%' : '33%'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <img
                    v-bind="attrs"
                    v-on="on"
                    src="/employment_index/Qustion.png"
                    width="22px"
                    alt="info"
                    class="v-align-middle"
                  />
                </template>

                <span
                  class="display-18"
                  v-html="CategoriesConstants.Keys[3].KeyValue.Value"
                ></span>
              </v-tooltip>
            </v-col>

            <v-col class="pr-md-2 pr-4">
              <p class="display-20 mb-0 mango-font">
                {{ CategoriesConstants.Keys[1].KeyValue.Value }}
              </p>
              <p class="display-16 mb-0">
                {{ CategoriesConstants.Keys[2].KeyValue.Value }}
              </p>
            </v-col>

            <iframe
              class=""
              :src="CategoriesGraphLinkDemand"
              frameborder="0"
              width="100%"
              :height="$vuetify.breakpoint.xs ? '300px' : '260x'"
            ></iframe>
          </v-row>
        </v-col>
      </v-row>
    </v-col>

    <v-col md="12" lg="4" cols="12" class="pl-10">
      <v-row>
        <v-col cols="12" class="pa-2 mx-2">
          <v-row>
            <v-col class="info-col rounded" cols="12">
              <v-row class="px-2 pt-2 pt-md-4">
                <v-col cols="1" class="pl-0 ml-n2">
                  <v-tooltip
                    :open-on-click="true"
                    :open-on-hover="true"
                    bottom
                    color="#525867"
                    :max-width="$vuetify.breakpoint.xs ? '90%' : '33%'"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <img
                        v-bind="attrs"
                        v-on="on"
                        src="/employment_index/Qustion.png"
                        width="22px"
                        alt="info"
                        class="v-align-middle"
                      />
                    </template>

                    <span
                      class="display-18"
                      v-html="CompetitionConstants.Keys[2].KeyValue.Value"
                    ></span>
                  </v-tooltip>
                </v-col>

                <v-col class="pr-md-2 pr-4 mb-0">
                  <p class="display-20 mb-0 mango-font">
                    {{ CompetitionConstants.Keys[0].KeyValue.Value }}
                  </p>
                  <p class="display-16 mb-0">
                    <span class="white--text">
                      {{ CompetitionConstants.Keys[1].KeyValue.Value }}
                    </span>
                  </p>
                </v-col>
                <iframe
                  class=""
                  :src="CareerChangeGraphLink"
                  frameborder="0"
                  width="100%"
                  :height="$vuetify.breakpoint.xs ? '300px' : '260x'"
                ></iframe>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="carrot-background my-2 rounded">
            <v-col class="px-0 px-md-5">
              <v-row class="pr-6">
                <v-col v-for="(tool, index) in ToolsLinks" :key="index">
                  <nuxt-link :to="tool.Link">
                    <v-row>
                      <v-col cols="1">
                        <img :src="toolsImages[index]" class="v-align-middle" />
                      </v-col>
                      <v-col>
                        <p
                          class="
                            white--text
                            display-14-10
                            mb-0
                            v-align-text-top
                          "
                        >
                          {{ tool.Title }}
                        </p>
                      </v-col>
                    </v-row>
                  </nuxt-link>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <ContentSlider :content="Articles" />
        </v-col>

        <v-row class="pa-2 pr-4">
          <v-col>
            <v-row class="fire-fox-font display-34 py-3 px-6">
              <p>
                {{ SearchCubeConstants.Keys[0].KeyValue.Value }}
              </p>
            </v-row>
            <SearchManager :employment="employment" />
          </v-col>
        </v-row>
      </v-row>
    </v-col>
    <p class="text-right white--text display-14 mb-2 pr-2" v-html="Asterisk" />
  </v-row>
</template>

<script>
import DrushimLogo from '~/components/NavigationMenu/DrushimLogo';
import ContentSlider from '@/components/EmploymentIndex/ContentSlider';
import SearchManager from '@/components/JobsSearch/SearchManager';
import InfoCube from '@/components/EmploymentIndex/InfoCube';
import ProgressBar from '@/components/EmploymentIndex/ProgressBar';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import { MEASURE_DATA, MEASURE_CATEGORY_DEMAND } from '@/lib/api.js';

export default {
  mixins: [SeoOptimization],
  layout: 'employmentIndex',
  components: {
    DrushimLogo,
    ContentSlider,
    SearchManager,
    InfoCube,
    ProgressBar,
  },

  data() {
    return {
      employment: true,
      displayCategory: undefined,
      toolsImages: [
        '/employment_index/Calculator.png',
        '/employment_index/Table.png',
        '/employment_index/cv.png',
      ],
    };
  },

  async asyncData(context) {
    try {
      const { data } = await context.$axios.get(`${MEASURE_DATA}`);

      if (data.IsError) {
        throw data.Errors;
      }

      return {
        MainCubeConstants: data.MainCubeConstants,
        CurrentDemandConstants: data.CurrentDemandConstants,
        IndexesConstants: data.IndexesConstants,
        CategoriesConstants: data.CategoriesConstants,
        CompetitionConstants: data.CompetitionConstants,
        SearchCubeConstants: data.SearchCubeConstants,
        CompetitionCubeConstants: data.CompetitionCubeConstants,
        EffortCubeConstants: data.EffortCubeConstants,
        Demand: data.Indexes.Demand,
        Supply: data.Indexes.Supply,
        Measure: data.Indexes.Measure,
        Articles: data.Articles,
        Effort: data.Indexes.EffortString,
        Competition: data.Indexes.CompetitionString,
        ToolsLinks: data.ToolsLinks,
        Categories: data.Categories,
        CategoriesGraphLinkDemand:
          data.CategoriesGraphsLinks.CategoryDemandGraph.Link,
        CategoriesGraphLinkSupply:
          data.CategoriesGraphsLinks.CategorySupplyGraph.Link,
        MostDemagedDomainsGraphLink:
          data.GeneralGraphsLinks.MostDemagedDomainsGraphLink,
        CareerChangeGraphLink: data.GeneralGraphsLinks.CareerChangeGraphLink,
        metaData: data.SEO.MetaDataItems,
        pageTitle: data.SEO.title,
        canonicalUrl: data.SEO.CanonicalUrl,
        Asterisk: data.Asterisk,
      };
    } catch (e) {
      context.error({
        statusCode: 404,
        path: context.route.fullPath,
        message: 'Dashboard error page ' + e,
      });
    }
  },
  head() {
    return {
      link: [{ rel: 'canonical', href: this.canonicalUrl }],
      title: this.pageTitle,
      meta: this.metaData,
    };
  },

  methods: {
    async submitCategory() {
      try {
        const { data } = await this.$axios.get(
          `${MEASURE_CATEGORY_DEMAND}?categorycode=${this.displayCategory}`
        );

        if (data.IsError) {
          throw data.Errors;
        }

        this.CategoriesGraphLinkDemand = data.CategoryDemandGraph.Link;
      } catch (e) {
        this.$nuxt.error({
          statusCode: 404,
          message: 'Dashboard error page ' + e,
        });
      }
    },
  },
};
</script>

<style>
.dark-gray-background {
  background: #1a1e28;
}
.employment {
  background-color: #262934;
}

.info-col {
  background-color: #30343d;
}

.gray-right {
  background-color: #494d58;
}
.gray-middle {
  background-color: #394051;
}
.gray-left {
  background-color: #525867;
}
.yellow-font {
  color: #f1bb29;
}
.green-font {
  color: #6bb56b !important;
}
.fire-fox-font {
  color: #fe6206;
}
.mango-font {
  color: #ee9e42;
}
.carrot-font {
  color: #f26c4f;
}
.carrot-background {
  background-color: #d74b3d;
}

.letter-space {
  letter-spacing: -1px;
}

a {
  text-decoration-line: none;
}

.show {
  display: none;
}
/* 
.align-bottom {
  vertical-align: end !important;
} */

@media only screen and (max-width: 600px) {
  .hide {
    display: none;
  }
  .show {
    display: block;
  }
}
</style>